
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/team",
      function () {
        return require("private-next-pages/community/team.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/team"])
      });
    }
  